import { system } from '@eastcoal/common/config/system'

import { RouterLink } from '@eastcoal/router/components/Link'

import { MemberApproveStatus } from '../../enums/MemberApproveStatus'
import { MemberApproveStatusTag } from '../MemberApproveStatusTag'

import { MemberApproveStatusLinkProps } from './interface'

export const MemberApproveStatusLink = ({
  approveStatus,
  hideSuccessStatus = true
}: MemberApproveStatusLinkProps) => {
  return hideSuccessStatus &&
    approveStatus === MemberApproveStatus.SUCCESS ? null : (
    <RouterLink
      title='点击前往认证管理页面'
      to={`${system.router.memberBaseUrl}/audit/list`}
    >
      <MemberApproveStatusTag
        approveStatus={approveStatus}
        hideSuccessStatus={hideSuccessStatus}
      />
    </RouterLink>
  )
}
